import { jsx } from "react/jsx-runtime";
import { createContext, useReducer } from "react";
import { noOp } from "../../utils/noOp.js";
import { SSOContextReducerActions } from "./constants.js";
const initialState = {
  apps: []
}, SSOContext = createContext({
  state: initialState,
  dispatch: noOp
});
function SSOContextProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return /* @__PURE__ */ jsx(SSOContext.Provider, { value: { state, dispatch }, children: props.children });
}
function reducer(state, action) {
  switch (action.type) {
    case SSOContextReducerActions.SetCurrentUser:
      return { ...state, currentUser: action.payload };
    case SSOContextReducerActions.SetApps:
      return {
        ...state,
        apps: action.payload
      };
    case SSOContextReducerActions.LogOut:
      return initialState;
    default:
      return state;
  }
}
export {
  SSOContext,
  SSOContextProvider
};
//# sourceMappingURL=SSOContext.js.map
